module.exports = __webpack_public_path__ + "assets/images/project/menu/russia-thumb.jpg?v=d15b2f55";